import React from 'react';
import BlogCard from 'components/artectum/cards/blog-card';
import { all_routes } from 'core/data/routes/all_routes';

const ProjectGrid = React.memo(({ projects }) => {
    const routes = all_routes;

    return (
        <div className="row">
            {projects.map((project, index) => (
                <div className="col-xl-4 col-sm-6 col-12" key={index}>
                    <BlogCard
                        image={project.banner_image}
                        title={project.title}
                        author={project?.autor}
                        tags={project?.tags}
                        date={project.date}
                        id={project.id}
                        detailsLink={routes.projectDetails + "/" + project.id}
                    />
                </div>
            ))}
        </div>
    );
});

export default ProjectGrid;
